define ['./dashboard.scss', './beta_modal.scss'], () ->
  ($scope, $rootScope, $state, $location, RentappService, hotkeys, $localStorage, MIN_DESKTOP_WIDTH, Flash, $http, RENTAPPLICATION_API_URL, $uibModal, BETA_FRONTEND_BASE_URL) ->
    $scope.show_spinner = false
    $scope.mobile_view = window.innerWidth < 768

    $rootScope.$on "intro-tour-started", (event, data) ->
      $scope.intro_started = true

    $rootScope.$on "first-form-tour-started", (event, data) ->
      $scope.first_form_started = true
    
    hotkeys.bindTo($scope)
    .add
      combo: 'a',
      description: 'View Applications'
      callback: () -> $state.go "root.dashboard.applications"
    .add
      combo: 'p',
      description: 'View Your Payments'
      callback: () -> $state.go "root.dashboard.payments"
    .add
      combo: 's',
      description: 'View Settings'
      callback: () -> $state.go "root.dashboard.landlord_settings"
    .add
      combo: "\\"
      description: 'Toggle Sidebar'
      callback: () -> $localStorage.sidebar_collapsed = !$localStorage.sidebar_collapsed
    .add
      combo: "q"
      description: 'Quick forms'
      callback: () -> $state.go "root.dashboard.quick_form"
    .add
      combo: "d"
      description: 'Quick forms display'
      callback: () -> $state.go "root.dashboard.quick_forms_display"

    $scope.dont_show_beta_flag = () -> 
      $localStorage.dont_show_beta_flag = true

    if !$localStorage.dont_show_beta_flag
      RentappService.getMe()
        .then (user) ->
          if $state.current.name == "root.dashboard"
            if !user.landlord
              $state.go "root.dashboard.applicant_applications"
            else
              $state.go "root.dashboard.forms"
          
          if user.landlord and user.landlord.show_edge_toggle
            setTimeout(() -> 
              if $scope.mobile_view
                banner = '<a id="switch-beta" style="color:white;" href="#">Your account will be automatically upgraded to the Redesign on December 12th. Click here to upgrade now!</a><br/><br/><a id="remove-flag" href="#">Don\'t show me this again</a>'
              else
                banner = '<a id="switch-beta" style="color:white" href="#">Your account will be automatically upgraded to the Redesign on December 12th. Click here to upgrade now!</a><a id="remove-flag" href="#" style="position:absolute; right:3rem;">Don\'t show me this again</a>'
              Flash.create('success', banner , 0, {class: "beta-promo" , container: 'beta'}, true)
              $scope.$digest()
              beta_link = document.getElementById('switch-beta')
              beta_link.addEventListener('click', (event) ->
                $uibModal.open
                  template: require("./beta_modal.jade")
                  windowClass: 'beta-modal'
                .result
                .then((result) ->
                  if result
                    $http.post("#{RENTAPPLICATION_API_URL}/api/v3/users/toggle_beta/")
                    .then (resp) -> 
                      location.href = "#{BETA_FRONTEND_BASE_URL}/login"
                    .catch (err) ->
                      console.log(err)
                )
              )
              remove_flag = document.getElementById('remove-flag')
              remove_flag.addEventListener('click', (event) ->
                $localStorage.dont_show_beta_flag = true
                Flash.clear()
                $scope.$digest()
              )
            , 100)
            

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) ->
      if toState.resolve
        $scope.show_spinner = true
    )
    
    $scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) ->
      if toState.resolve
        $scope.show_spinner = false
    )




// WEBPACK FOOTER //
// ./components/dashboard/dashboard.coffee